import {Component} from '@angular/core';
import {LovValue} from '../../model/LovValue.model';
import {IDialogComponent} from '../../../../../dialog/iDialog.component';
import {DialogWithInput} from '../../../../../dialog/dialogWithInput';

export interface LovValueSaveDialogInput {
    lovListName?: string;
}
export interface LovValueSaveDialogResult {
    lovValue: LovValue;
}

@Component({
    selector: 'app-lov-value-update-modal',
    templateUrl: './lov-value-update-modal.component.html',
})
export class LovValueUpdateModalComponent implements
    IDialogComponent<LovValueSaveDialogInput, LovValueSaveDialogResult> {
    dialog: DialogWithInput<LovValueSaveDialogInput, LovValueSaveDialogResult>;
    constructor() {
    }

    onEntitySaved(entity: LovValue) {
        this.dialog.close({
            lovValue: entity
        });
    }

}
